export const CLOSE_POPUP_WINDOW = 'CLOSE_POPUP_WINDOW';
